import styled from 'styled-components'
import Link from 'components/elements/Link'

const LinkButton = styled(Link)`
  background: #21ba45;
  color: #fff;

  padding: 0.57rem;
  border-radius: 5px;

  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: #fff;
    background: #16ab39;
  }
`

export default LinkButton
